// Puerto de packages/hce/src/hce/paciente/FarmaciaTab.tsx — Módulo H,
// Grupo 4. El formulario clínico manual de dispensación (FormularioDispensacion)
// se retiró 2026-09-11: "Vender" en Órdenes es el único camino de venta de
// farmacia interna, y ahora es lo que además deja el rastro en el HCE
// (MedicationDispense). El link de acá lleva directo a Órdenes con este
// paciente preseleccionado — mismo destino que un clic en la cola de recetas
// (ver ColaRecetas.tsx).
import type { JSX } from 'react';
import { useTranslation } from 'react-i18next';
import { Link, useParams } from 'react-router';

export function FarmaciaTab(): JSX.Element {
  const { t } = useTranslation();
  const { id } = useParams() as { id: string };

  return (
    <div>
      <h5 className="mb-3 text-sm font-semibold">{t('hub.farmaciaInterna')}</h5>
      <ul>
        <li>
          <Link className="text-sm text-hce-pine underline-offset-2 hover:underline" to={`/farmacia/facturacion?paciente=${id}`}>
            {t('farmacia.irAOrdenes')}
          </Link>
        </li>
      </ul>
    </div>
  );
}
